export const REMOVE_EDUCATION_PENDING = "REMOVE_EDUCATION_PENDING";
export const REMOVE_EDUCATION_SUCCESS = "REMOVE_EDUCATION_SUCCESS";
export const REMOVE_EDUCATION_ERROR = "REMOVE_EDUCATION_ERROR";

export const GET_EDUCATIONS_PENDING = "GET_EDUCATIONS_PENDING";
export const GET_EDUCATIONS_SUCCESS = "GET_EDUCATIONS_SUCCESS";
export const GET_EDUCATIONS_ERROR = "GET_EDUCATIONS_ERROR";

/** REMOVE **/
export const removeEducationPending = () => {
  return { type: REMOVE_EDUCATION_PENDING };
};

export const removeEducationSuccess = (payload) => {
  return { type: REMOVE_EDUCATION_SUCCESS, payload };
};

export const removeEducationError = (message) => {
  return { type: REMOVE_EDUCATION_ERROR, message };
};

/** GET **/
export const getEducationsPending = () => {
  return { type: GET_EDUCATIONS_PENDING };
};

export const getEducationsSuccess = (payload) => {
  return { type: GET_EDUCATIONS_PENDING, payload };
};

export const getEducationsError = (message) => {
  return { type: GET_EDUCATIONS_ERROR, message };
};

